// if (window.innerWidth < 768) {
// const variantSelects = document.querySelector('variant-selects');
// if (variantSelects) {
//   const formElement = variantSelects.nextElementSibling;
//   const ulElement = formElement && formElement.nextElementSibling;

//   if (formElement && ulElement && ulElement.tagName === 'UL') {
//     const wrapperDiv = document.createElement('div');
    
//     wrapperDiv.classList.add('mobile_wrapper');         // Set custom class

//     variantSelects.parentNode.insertBefore(wrapperDiv, variantSelects);
//     wrapperDiv.appendChild(variantSelects);
//     wrapperDiv.appendChild(formElement);
//     wrapperDiv.appendChild(ulElement);
//   }
// }
// }


window.addEventListener('scroll', function() {
  var headerWrapper = document.querySelector('.header-wrapper');
  if (window.scrollY > 0) {
    headerWrapper.classList.add('header-scrolled');
  } else {
    headerWrapper.classList.remove('header-scrolled');
  }
});


const customOrderButton = document.querySelectorAll('.custom_order_header');
const customForm = document.querySelector('.custom_form');
const closeOrder = document.querySelector('.order_close')
customOrderButton.forEach(formBtn => {
formBtn.addEventListener('click', function() {
    customForm.classList.add('open_form');
});
  });

closeOrder.addEventListener('click', function() {
     customForm.classList.remove('open_form');
});

const mainBody = document.querySelector("body");
const popupBtns = document.querySelectorAll('.popup_btn');
popupBtns.forEach(btn => {
    btn.addEventListener('click', function(event) {
      event.preventDefault();     
        const targetId = this.getAttribute('data-target');  
        const targetElement = document.querySelector(targetId);
        if (targetElement) {
            targetElement.classList.add('popup-open', 'open');
          mainBody.classList.add("open");
        }
    });
});
const closeButtons = document.querySelectorAll(".close_btn");
closeButtons.forEach((closeBtn) => {
  closeBtn.addEventListener("click", () => {
    const popupDiv = closeBtn.closest(".poup_modal"); 
    if (popupDiv) {
      popupDiv.classList.remove("popup-open");
      mainBody.classList.remove("open");
    }
  });
});


function checkScreenSize() {
    return window.innerWidth < 1024;
}

function handleItemClick(event) {
    const currentItem = event.currentTarget;
    const allItems = document.querySelectorAll('.grid__item');

    if (!currentItem.classList.contains('your-class')) {
        allItems.forEach(item => item.classList.remove('your-class'));
        currentItem.classList.add('your-class');
        event.preventDefault();
    }
}

document.querySelectorAll('.grid__item').forEach(function(item) {
    if (checkScreenSize()) {
        item.addEventListener('click', handleItemClick);
    }
});


window.addEventListener('resize', function() {
    if (checkScreenSize()) {
        document.querySelectorAll('.grid__item').forEach(function(item) {
            item.addEventListener('click', handleItemClick);
        });
    } else {
        document.querySelectorAll('.grid__item').forEach(function(item) {
            item.removeEventListener('click', handleItemClick);
        });
    }
});

document.querySelector('.drawer_close').addEventListener('click', function() {
    document.querySelector('.menu-drawer-container').classList.remove('menu-opening');
    document.body.classList.remove('overflow-hidden-tablet', 'open_sidebar');
});

document.addEventListener('DOMContentLoaded', function() {
    let sizeSelect = document.querySelector("select[name='options[Size]']");
    if (sizeSelect) {
        let defaultOption = document.createElement('option');
        defaultOption.text = 'Select size..';
        defaultOption.value = '';
        defaultOption.disabled = true;
        defaultOption.selected = true;
        sizeSelect.insertBefore(defaultOption, sizeSelect.firstChild);
    }
});


const footerBtns = document.querySelectorAll('.footer-block.menu-1 li');
footerBtns.forEach(btn => {
    btn.addEventListener('click', function(event) {
      event.preventDefault();
        const targetId = this.getAttribute('data-val'); 
      console.log(targetId);
        const footerElement = document.querySelector(targetId);
        if (footerElement) {
            footerElement.classList.add('popup-open', 'open');
          mainBody.classList.add("open");
        }
    });
});
